var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttachment = function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.507 2.743a1.56 1.56 0 0 0-2.206 0l-4.498 4.5a2.616 2.616 0 0 0 0 3.703 2.623 2.623 0 0 0 3.706 0l3.56-3.563a.562.562 0 0 1 .795.795l-3.56 3.565a3.746 3.746 0 0 1-5.297-5.297l4.5-4.5a2.683 2.683 0 1 1 3.797 3.795l-4.308 4.307a1.758 1.758 0 0 1-2.484-2.484l3.557-3.556a.562.562 0 0 1 .795.795L5.308 8.361a.629.629 0 1 0 .89.89l4.309-4.305c.609-.61.609-1.596 0-2.205z"
  })));
};
export default SvgAttachment;